// extracted by mini-css-extract-plugin
module.exports = {"container":"answerItem_container__SSdSJ","buttonSvg":"answerItem_buttonSvg__10HuA"};